import { brand, footerLinks } from "../data/siteData";
import "./Footer.css";

/* Navigate to #products and fire the category selector event */
function goToCategory(id) {
  document.getElementById('products')?.scrollIntoView({ behavior: 'smooth' });
  window.dispatchEvent(new CustomEvent('selectProductCategory', { detail: id }));
}

export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer__top">

        {/* Brand column */}
        <div className="footer__brand">
          <div className="footer__logo">🌿 <span>{brand.name}</span></div>
          <div className="footer__brand-tagline">{brand.tagline}</div>
          <p className="footer__brand-desc">
            Protecting crops. Empowering farmers. Building a food-secure world since 2017.
          </p>
          <div className="footer__eco-badges">
            {["🌍 Carbon Neutral", "♻️ Eco Safe", "✅ Certified"].map((b) => (
              <span className="footer__eco-badge" key={b}>{b}</span>
            ))}
          </div>
          <div className="footer__social">
            {[
              { icon: "𝕏",  href: brand.social.twitter,  label: "Twitter"   },
              { icon: "f",  href: brand.social.facebook,  label: "Facebook"  },
              { icon: "in", href: brand.social.linkedin,  label: "LinkedIn"  },
              { icon: "▶",  href: brand.social.youtube,   label: "YouTube"   },
            ].map((s) => (
              <a
                key={s.label}
                href={s.href && s.href !== '#' ? s.href : undefined}
                className={`footer__social-btn${(!s.href || s.href === '#') ? ' footer__social-btn--inactive' : ''}`}
                aria-label={s.label}
                target={s.href && s.href !== '#' ? '_blank' : undefined}
                rel="noopener noreferrer"
                onClick={(!s.href || s.href === '#') ? (e) => e.preventDefault() : undefined}
              >
                {s.icon}
              </a>
            ))}
          </div>
        </div>

        {/* Link columns */}
        {Object.entries(footerLinks).map(([heading, links]) => (
          <div className="footer__col" key={heading}>
            <h4>{heading}</h4>
            <ul>
              {links.map((link) => {

                /* 1. Product category links → fire carousel event */
                if (typeof link === 'object' && link.id) {
                  return (
                    <li key={link.label}>
                      <a href="#products" onClick={(e) => { e.preventDefault(); goToCategory(link.id); }}>
                        {link.label}
                      </a>
                    </li>
                  );
                }

                /* 2. null href → coming soon, not clickable */
                if (typeof link === 'object' && link.href === null) {
                  return (
                    <li key={link.label}>
                      <span className="footer__link-dead">
                        {link.label}
                        <span className="footer__coming-soon">Soon</span>
                      </span>
                    </li>
                  );
                }

                /* 3. mailto: / tel: → open directly, no scroll */
                if (typeof link === 'object' && link.href && (link.href.startsWith('mailto:') || link.href.startsWith('tel:'))) {
                  return (
                    <li key={link.label}>
                      <a href={link.href} className="footer__link-contact">{link.label}</a>
                    </li>
                  );
                }

                /* 4. Internal anchor #id → smooth scroll */
                if (typeof link === 'object' && link.href && link.href.startsWith('#')) {
                  return (
                    <li key={link.label}>
                      <a
                        href={link.href}
                        onClick={(e) => {
                          e.preventDefault();
                          document.getElementById(link.href.slice(1))?.scrollIntoView({ behavior: 'smooth' });
                        }}
                      >
                        {link.label}
                      </a>
                    </li>
                  );
                }

                /* 5. External URL → open in new tab */
                if (typeof link === 'object' && link.href) {
                  return (
                    <li key={link.label}>
                      <a href={link.href} target="_blank" rel="noopener noreferrer">{link.label}</a>
                    </li>
                  );
                }

                /* 6. Plain string fallback */
                return <li key={link}><span className="footer__link-dead">{link}</span></li>;
              })}
            </ul>
          </div>
        ))}

      </div>

      <div className="footer__bottom">
        <span>© {new Date().getFullYear()} {brand.name} Agrosciences. All rights reserved.</span>
        <span>Privacy · Terms · Safety Data · Regulatory</span>
      </div>
    </footer>
  );
}